
import Vue from 'vue'

export const setPF = (state, payload) => {
	if(payload) {
		localStorage.setItem('caseFileClient', payload.client_id)
		console.log(localStorage.caseFileClient)
		return Vue.set(state, 'pf', {...payload})
	}

	Vue.set(state, 'pf', null)
}